import request from '@/utils/request'


// // 获取首頁信息
// export function getIndexData() {
//     return request({
//         url: '/h5/index/getIndexData', method: 'get'
//     })
// }


// 获取首頁信息
export function getIndexData() {
    return request({
        url: '/h5/index/getIndexData',
        method: 'get'
    })
}

// 获取证书项目列表
export function getProjectList(type) {
    if (!type) {
        type = ''
    }
    return request({
        url: '/h5/index/getProjectList?type=' + type,
        method: 'get'
    })
}


// 获取团队信息
export function getDeptList() {
    return request({
        url: '/h5/index/getDeptList',
        method: 'get'
    })
}
